import dayjs, { Dayjs } from 'dayjs'

type DateLike = string | number | Date | Dayjs | null | undefined

// Temporary workaround: compare exact UTC timestamps end-to-end.
// Future plan: if business switches to tenant/port-local calendar-day semantics,
// replace these helpers with timezone-aware date-boundary comparison.
export const isAfterValidityTimestamp = (actual: DateLike, validity: DateLike): boolean => {
  if (!actual || !validity) return false
  return dayjs(actual).isAfter(dayjs(validity))
}

export const isValidityExpiredByNow = (validity: DateLike): boolean => {
  if (!validity) return false
  return dayjs().isAfter(dayjs(validity))
}
